export default __webpack_public_path__ + "static/media/hacker2-en.da9bb356.png";